import { useRouter } from 'next/router';
import React, { memo } from 'react';
import { useTranslation } from 'next-i18next';

import { ButtonV3 } from 'components/ComponentV2';
import ProfilePics from 'components/candidate/ProfilePics';
import { Col, Row } from 'components/layout';
import { PAGE_ROUTES } from 'lib/page-routes';

import { useAttendeesFilter } from '../useAttendeesFilter';

import styles from './WaitingCard.module.scss';

export const WaitingCard: React.FC = memo(() => {
  const router = useRouter();

  const { id } = router.query;

  const [t] = useTranslation('event-dashboard');

  const { touchpointDashboard } = useAttendeesFilter();

  const { waitlist_count } = touchpointDashboard || {};

  if (!waitlist_count) {
    return null;
  }

  return (
    <div className={styles.WaitlistCard}>
      <Row align="center" justify="space-between">
        <Col>
          <Row className={styles.info} align="center">
            <Col>
              <ProfilePics
                maxPicsToShow={waitlist_count === 1 ? waitlist_count : 2}
                urls={[]}
                className={styles.profile}
              />
            </Col>
            <Col className={styles.infoText}>
              <p className={styles.title}>
                {waitlist_count === 1
                  ? t('waiting-card.guest-count', { count: waitlist_count })
                  : t('waiting-card.guests-count', { count: waitlist_count })}
              </p>
            </Col>
          </Row>
        </Col>
        <Col className={styles.buttons}>
          <ButtonV3
            onClick={() => {
              router.push(
                PAGE_ROUTES.EVENT_MANAGEMENT_DASHBOARD.replace(
                  '[id]',
                  id as string
                ) + '?tab=guests&waitlist=true'
              );
            }}
            borderless
            startIcon="icon_check-list"
          >
            {t('waiting-card.review')}
          </ButtonV3>
        </Col>
      </Row>
    </div>
  );
});

WaitingCard.displayName = 'WaitingCard';
